import { render, staticRenderFns } from "./BeyondTheBookHBF.vue?vue&type=template&id=6f0fbda1&scoped=true"
import script from "./BeyondTheBookHBF.vue?vue&type=script&lang=js"
export * from "./BeyondTheBookHBF.vue?vue&type=script&lang=js"
import style0 from "./BeyondTheBookHBF.vue?vue&type=style&index=0&id=6f0fbda1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0fbda1",
  null
  
)

export default component.exports